import { render, staticRenderFns } from "./GapClosureArchive.vue?vue&type=template&id=6bb956b8&scoped=true"
import script from "./GapClosureArchive.vue?vue&type=script&lang=js"
export * from "./GapClosureArchive.vue?vue&type=script&lang=js"
import style0 from "./GapClosureArchive.vue?vue&type=style&index=0&id=6bb956b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb956b8",
  null
  
)

export default component.exports